module.exports = __webpack_public_path__ + "img/ice_queen_small.8cfd89bf.png";